import React from 'react'
import { useValue } from '@morningtrain/react-resources'
import * as moment from 'moment'
import { VacationRequestSmartview } from 'widgets/smartviews/vacation-requests/VacationRequestSmartview'
import MountSmartviewWithModelOnClick from 'support/utilities/MountSmartviewWithModelOnClick'

export default function VacationRequestEntry (props) {
  const status = useValue('status')
  const createdAt = moment(useValue('created_at', null))

  return (
    <MountSmartviewWithModelOnClick smartview={<VacationRequestSmartview/>}>
      <a
        className={'entry ' + status}
        title={'Anmodningsdato: ' + createdAt.format('D. MMM Y')}
        style={props.position}
      />
    </MountSmartviewWithModelOnClick>
  )
}
